<template>
  <div class="c-document-library u-bg-color-brand-two-lighten-100">
  <div class="grid-container">
    <div class="c-document-library__intro">
      <div class="c-document-library__header-holder">
        <h2 :is="headingTag || 'H2'" class="c-document-library__heading u-text-color-brand-two">{{ heading }}</h2>
      </div>
      <div class="filter-holder" v-if="levelTags && levelTags.length || topicTags && topicTags.length">
        <div class="c-list-filter">
          <div class="c-list-filter__button">
              <filter-button name="Filter" @clicked="toggleMobileFilter" />
          </div>
          <div class="c-list-filter__options" :class="[isMobileFilterOpen ? 'c-list-filter__options--active' : '']">
            <div class="c-list-filter__item" v-if="levelTags && levelTags.length">
              <filter-dropdown v-model="selectedLevelTag" :label="primaryTagsLabel || 'Category'" :options="levelTags" @changed="getData" />
            </div>
            <div class="c-list-filter__item" v-if="topicTags && topicTags.length">
              <filter-dropdown v-model="selectedTopicTag" :label="secondaryTagsLabel || 'Topic'"  :options="topicTags" @changed="getData"  />
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade" appear mode="out-in">
      <div v-if="hasResultsLoaded" key="results">
        <div class="c-document-library__grid" v-if="results.length">
          <document-library-card v-for="item in results" :item="item" :key="item.id" />
        </div>
        <div class="c-document-library__message" v-else>
          Sorry, no results found.
        </div>
      </div>
      <div class="c-document-library__message" v-else-if="hasError" key="error">
        Sorry, something went wrong.
      </div>
      <div class="c-document-library__message" v-else key="loading">
        <div class="lds-facebook"><div></div><div></div><div></div></div>
      </div>
    </transition>
  </div>
</div>

</template>

<script>
  import "url-search-params-polyfill";
  import DocumentLibraryCard from './DocumentLibraryCard.vue'
  import FilterDropdown from '../_filter/filter-dropdown/FilterDropdown.vue'
  import FilterButton from '../_filter/filter-button/FilterButton.vue'
  import axios from "axios";
  import endpoints from "Globals/mando.endpoints";

  export default {
    name: "DocumentLibrary",
    components: {
      DocumentLibraryCard,
      FilterDropdown,
      FilterButton
    },
    props: {
      heading: {
        required: true,
        type: String
      },
      topicTags: {
        required: true,
        type: Array
      },
      levelTags: {
        required: true,
        type: Array
      },
      componentId: {
        required: true,
        type: String
      },
      siteId: {
        required: true,
        type: String
      },
      primaryTagsLabel: {
        required: false,
        type: String,
        default: 'Catagory'
      },
      secondaryTagsLabel: {
        required: false,
        type: String,
        default: 'Topic'
      },
      headingTag: {
        required: false,
        type: String,
        default: 'H2'
      }
    },
    data() {
      return {
        results: [],
        selectedLevelTag: '',
        selectedTopicTag: '',
        hasResultsLoaded: false,
        hasError: false,
        isMobileFilterOpen: false,
      }
    },
    computed: {
      apiParams() {
        const params = {}
        params.componentId = this.componentId
        params.siteId = this.siteId
        if(this.selectedLevelTag) {
          params.level = this.selectedLevelTag
        }
        if(this.selectedTopicTag) {
          params.topic = this.selectedTopicTag
        }
        return params
      }
    },
    methods: {
      getResultsFail(response) {
        this.hasError = true
        console.log('Error', response)
      },
      getResultsSuccess(response) {
        this.results = response.data.results
        this.hasResultsLoaded = true
      },
      getData() {
        this.hasResultsLoaded = false
        axios
        .get(endpoints('getDocumentLibrary'), { params: this.apiParams })
        .then(this.getResultsSuccess.bind(this))
        .catch(this.getResultsFail.bind(this))
      },
      toggleMobileFilter(payLoad) {
        this.isMobileFilterOpen = payLoad
      }
    },
    mounted() {
      this.getData()
    }
  };
  

</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/document-library/DocumentLibrary.vue